import { createContext } from "react";
import { Workspace } from "../../generated/core-api";

export const WorkspaceContext = createContext<Workspace | undefined>(undefined);
